<cam-loader [isLoading]="this.requestState.isLoading()">
  <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
    @if (this.form) {
      <cam-form
        [inputs]="this.form"
        (valid)="this.createTemplate($event)"
        [loader]="this.requestState.isLoading()"
      ></cam-form>
    }
  </cam-error>

  @let template = this.template$ | async;
  <div class="pt-space-xl">
    @if (template) {
      @if (this.id(); as id) {
        <cam-communication-template-variant-edit
          [id]="id"
          [variants]="template.variants"
        ></cam-communication-template-variant-edit>
      }
    }
  </div>
</cam-loader>
